import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";
import { FC, Fragment } from "react";
import { v4 } from "uuid";
import { useAppSelector } from "../../store/hooks";
import store from "../../store/store";
import { formActions, initialState } from "../../store/submit-form-slice";
import { SubmitStatus } from "../model/submit-response";
import { useNavigate } from "react-router-dom";

const PPDialog: FC<{
  title: string;
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ title, state, setState }) => {
  const { success, messages, status, traceId } = useAppSelector(
    (state) => state.submit
  );
  const navigate = useNavigate();

  const handleClose = (event: object, reason?: string) => {
    if (reason !== "backdropClick") {
      setState(false);
      store.dispatch(formActions.submit(initialState));
    }
    if (success) navigate(0);
  };

  let bodyComponent: JSX.Element[] | JSX.Element | undefined = undefined;
  if (status == SubmitStatus.VALIDATING) {
    bodyComponent = (
      <Fragment key={v4()}>
        <DialogContentText variant="body2" id="alert-dialog-description">
          {"Validating..."}
        </DialogContentText>
        <LinearProgress />
      </Fragment>
    );
  } else if (status == SubmitStatus.FORM_SUBMITTED && messages) {
    bodyComponent = messages.map((e) => {
      return (
        <Fragment key={v4()}>
          <DialogContentText
            sx={{ padding: "10px" }}
            color={success ? "inherit" : "red"}
            variant="body2"
            id="alert-dialog-description"
          >
            {e.message}
          </DialogContentText>
          <Divider />
        </Fragment>
      );
    });
  } else if (
    status == SubmitStatus.GET_UPLOAD_URL ||
    status == SubmitStatus.READ_LOCAL_FILES
  ) {
    bodyComponent = (
      <Fragment key={v4()}>
        <DialogContentText variant="body2" id="alert-dialog-description">
          {status == SubmitStatus.GET_UPLOAD_URL
            ? "Initializing Uploads..."
            : "Preparing Files..."}
        </DialogContentText>
        <LinearProgress />
      </Fragment>
    );
  } else if (status == SubmitStatus.UPLOAD_TO_S3) {
    bodyComponent = (
      <Fragment key={v4()}>
        <DialogContentText variant="body2" id="alert-dialog-description">
          {"Sending File " +
            (store.getState().submit.fileProgress + 1) +
            " out of " +
            store.getState().files.length}
        </DialogContentText>
        <LinearProgress
          variant="determinate"
          value={store
            .getState()
            .submit.dataProgress.reduce((p, c) => p + c, 0)}
        />
      </Fragment>
    );
  } else if (status == SubmitStatus.SUBMIT_FORM) {
    bodyComponent = (
      <Fragment key={v4()}>
        <DialogContentText variant="body2" id="alert-dialog-description">
          {"Submitting Form..."}
        </DialogContentText>
        <LinearProgress />
      </Fragment>
    );
  } else if (
    status == SubmitStatus.FORM_SUBMISSION_FAILED ||
    status == SubmitStatus.UPLOADS_FAILED
  ) {
    bodyComponent = (
      <Fragment key={v4()}>
        <DialogContentText
          variant="body2"
          color={"red"}
          id="alert-dialog-description"
        >
          {status == SubmitStatus.FORM_SUBMISSION_FAILED
            ? "Failure: Network Error"
            : "Failure: Form Not Submitted."}
        </DialogContentText>
      </Fragment>
    );
  } else {
    bodyComponent = (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item>
          <LinearProgress />
        </Grid>
      </Grid>
    );
  }

  let successStatusMessage = success ? ": Success" : ": Failed";

  return (
    <Dialog
      open={state}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Form Submission" + (messages ? successStatusMessage : "")}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {!success && messages ? "Validation Errors:" : ""}
        </Typography>
        {bodyComponent}
      </DialogContent>
      <DialogContentText
        align={"center"}
        color={success ? "inherit" : "red"}
        variant="caption"
        id="alert-dialog-description"
      >
        {!success && traceId ? "Trace ID: " + traceId : null}
      </DialogContentText>
      <DialogActions>
        {messages ||
        status == SubmitStatus.FORM_SUBMISSION_FAILED ||
        status == SubmitStatus.UPLOADS_FAILED ? (
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default PPDialog;
//PPDialog.whyDidYouRender = true;
